<template>
  <div class="matrix-compose">
    <q-table
      ref="table"
      :view="view"
      :rows="issue.rows"
      :columns="issue.items"
      show-required
      :row-desc="issue.rowDesc"
      :widths="issue.widths"
    >
      <template v-slot:content="{ row, col }">
        <div>
          <compose-item
            :row="row"
            :col="col"
            :cell="issue.getCellByItemId(col.id)"
            :cache-value="issue.getValueByRowAndCol(row, col)"
            @change="onChangeValue"
          />
          <template v-if="row.errMap[col.id]">
            <div>
              <span class="text-red mt-1 text-small">{{ row.errMap[col.id] }}</span>
            </div>
          </template>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixTable'
import ComposeItem from '@/questions/components/ComposeItem'
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixCompose',
  changeExpr: 'issue.value',
  components: { QTable, ComposeItem, MatrixTable },
  methods: {
    onChangeValue(value) {
      this.issue.addValue(value.slice())
      setTimeout(()=>{
        this.$refs.table.initTable()
      },30)
    }
  },
  created() {
    this.question.setHook('submitError', () => {
      this.$nextTick(() => {
        this.$refs.table.initTable()
      })
    })
    this.question.setHook('submitSuccess', () => {
      this.$nextTick(() => {
        this.$refs.table.initTable()
      })
    })
  }
}
</script>

<style scoped></style>
